import React, { Component } from 'react'
import Chart from 'chart.js'
import PropTypes from 'prop-types';

class DoughNutChart extends Component {
    constructor(props) {
        super(props)
        this.canvasRef = React.createRef();
    }

    componentDidUpdate() {
        this.featureChart.labels = this.props.labels;
        this.featureChart.data.datasets[0].data = this.props.data;
        this.featureChart.update();
    }

    componentDidMount() {
        this.featureChart = new Chart(this.canvasRef.current, {
            type: 'doughnut',
            options: {
                maintainAspectRatio: true,
                legend: {
                    display: false
                },
                responsive: true,
            },
            data: {
                labels: this.props.labels,
                datasets: [{
                    data: this.props.data,
                    backgroundColor: ['#8FDB00', '#622AD8']
                }]
            }
        });
    }

    render() {
        return (
            <div data-test='automateKpitjav2DoughNutChartComponent'>
                <canvas id="featureChart" style={{ height: "12rem" }} ref={this.canvasRef} />
            </div>
        )
    }
}
DoughNutChart.propTypes = {
    labels: PropTypes.array,
    data: PropTypes.array,
}
DoughNutChart.defaultProps = {
    labels: [],
    data: [],
}

export default DoughNutChart;
